import { render } from "./HourglassLoader.vue?vue&type=template&id=7860336a"
import script from "./HourglassLoader.vue?vue&type=script&lang=js"
export * from "./HourglassLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__